// ui/src/app/services/permission.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private readonly storageKey = 'userPermissions';

  // Set permissions for a section
  setPermissions(section: string, permissions: Record<string, boolean>): void {
    const allPermissions = this.getAllPermissions();
    allPermissions[section] = permissions;
    localStorage.setItem(this.storageKey, JSON.stringify(allPermissions));
  }

  // Get all permissions for a section
  getPermissions(section: string): Record<string, boolean> | null {
    const allPermissions = this.getAllPermissions();
    return allPermissions[section] || null;
  }

  // Get a specific permission from a section
  getPermission(section: string, key: string): boolean {
    const sectionPermissions = this.getPermissions(section);
    return sectionPermissions ? sectionPermissions[key] : null;
  }

  // Get all permissions (all sections)
  getAllPermissions(): Record<string, Record<string, boolean>> {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : {};
  }

  // Clear all permissions
  clearPermissions(): void {
    localStorage.removeItem(this.storageKey);
  }
}
